module.exports = __webpack_public_path__ + "static/media/DW_Favicon.d26f9b1b.png";